// drawer/components/NotificationModal.tsx
import { Modal } from '@/components/Modal';

interface NotificationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
  actionType: 'acknowledge' | 'acknowledge-scanning' | null;
}

/**
 * Confirmation modal for sending threat notifications
 */
export function NotificationModal({
  open,
  onClose,
  onConfirm,
  isPending,
  actionType,
}: NotificationModalProps) {
  return (
    <Modal
      title="Send Customer Notification?"
      open={open}
      onClose={isPending ? () => {} : onClose}
      footer={{
        text: isPending ? 'Sending...' : 'Send Notification',
        className: 'min-w-40',
        disabled: isPending,
        onClick: onConfirm,
      }}
    >
      <div className="space-y-4">
        <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-4 dark:border-yellow-800 dark:bg-yellow-900/20">
          <p className="mb-2 font-semibold text-yellow-800 dark:text-yellow-200">
            Warning: This will notify all customers
          </p>
          <p className="text-sm text-yellow-700 dark:text-yellow-300">
            This action will send a notification to all customers with
            configured notification integrations.
          </p>
        </div>
        <p className="text-chariot-text-secondary text-sm">
          Are you sure you want to send this{' '}
          {actionType === 'acknowledge-scanning'
            ? 'acknowledgement + scanning'
            : 'threat acknowledgement'}{' '}
          notification?
        </p>
      </div>
    </Modal>
  );
}
